module.exports = __webpack_public_path__ + "img/chat.bb52a79d.svg";